import { render, staticRenderFns } from "./index.vue?vue&type=template&id=00d1537a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=00d1537a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d1537a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeading: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/page-heading.vue').default,DataFilter: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/data-filter.vue').default})
